import OkC from "shared/util/OkcApi";
import jQuery from "jquery";

/* ----------------------------------------------------------------

OkCupid Utilities file

	- usefulish stuff

This file contains general utilities used through the site

---------------------------------------------------------------- */

window.util = window.Utilities = {

	/* String functions --------------------------------------------------------------------------- */

	jogf: function(string, key)
	{
		// IE needs the var
		for (const item in key)
		{ string = string.replace(`%${item}`, key[item]); }
		return string;
	},

	/* http://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex */
	escapeRegExp: function(str) {
	  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
	},

	/* Math functions ----------------------------------------------------------------------------- */

	roundNumber: function(num, dec) {
		return Math.round(num * Math.pow(10, dec)) / Math.pow(10, dec);
	},

	/* Interface ---------------------------------------------------------------------------------- */


	toggle: function(obj) {
		const element = jQuery(`#${obj}`);
		if (element.is(":visible")) {
			element.hide();
		} else {
			element.show();
		}
	},


	/* Site specific ------------------------------------------------------------------------------ */


	//     name: your stat name
	//     value: an integer
	//     type: "counter" or "value", depending on which kind of stat it is
	//     hash: a hash of your stat name to prove a user didn't make it up. To find
	//           your stat name's hash, just visit www.okcupid.com/poststat from
	//           a staff IP.
	//     optional_params:
	//        redirect_to: send to this URL on callback; makes for easy click tracking
	//        cb: code to execute upon completion

	updateStats: function(name, value, type, hash, optional_params) {
		OkC.post("/okc/updatestats", {
			api: 1,
			data: {
				"name": name,
				"value": value,
				"type": type,
				"hash": hash,
			},
		})
			.then(function(_this) {
				return function(res) {
					_this.updateStats_cb(res, optional_params);
				};
			}(this))
			.catch(function(_this) {
				return function(e) {
					console.error("Stat failed: ", name, " with error: ", e);
					_this.updateStats_cb(e, optional_params);
				};
			}(this));
	},

	updateStats_cb: function(transport, optional_params) {
		if (optional_params && optional_params.cb) {
			optional_params.cb();
		}
		if (optional_params && optional_params.redirect_to) {
			window.location.href = optional_params.redirect_to;
		}
	},


	/* bad ad functions ----- */

	toggleBadAdOverlay: function(adformat) {
		// Initialize overlay if it hasn't been yet.
		const modal = jQuery("#" + "bad_ads_overlay");
		if (modal.hasClass("show")) {
			window.Modal.close("bad_ads_overlay");
		} else {
			jQuery("#" + "bad_ads_form").show();
			jQuery("#" + "bad_ads_overlay .buttons").show();
			jQuery("#" + "bad_ad_thanks").hide();
			window.Modal.open("bad_ads_overlay");
			new OkForm("bad_ads_form");

			// select the passed-in adformat
			jQuery("#" + "bad_ad_format").val(adformat);

			// trigger an update to the dropdown view
			jQuery("#bad_ad_format").trigger("chosen:updated");
		}
	},

	// simple profiling
	domloaded: false,
	m_dom_load_funcs: [],

	doOnDomLoad: function(func) {
		if (this.domloaded) {
			func();
		} else {
			this.m_dom_load_funcs.push(func);
		}
	},

	executeDomLoad: function() {
		this.domloaded = true;
		if (this.m_dom_load_funcs) {
			for (let i = 0; i < this.m_dom_load_funcs.length; i++) {
				setTimeout(this.m_dom_load_funcs[i], 500);
			}
		}
	},

	toggleClass: function(element, classname) {
		const el = jQuery(element);
		el.toggleClass(classname);
	},

	// e.g. util.toMask(0,1,6) returns 67  because 1000011 is 67.
	toMask: function() {
		let res = 0,
			bits;

		if (typeof arguments[0] === "object")
		{ bits = arguments[0]; }
		else
		{ bits = arguments; }

		for (let i = 0; i < bits.length; i++) {
			if (bits[i] > 31 || bits[i] < 0)
			{ throw ("fillBitsInMask expects ints in [0..30] due to JS bitwise limitations"); }
			res |= Math.pow(2, bits[i]);
		}
		return res;
	},

	// inversion of above function; util.fromMaskToList(67) returns [0,1,6]
	fromMaskToList: function(mask) {
		const res = [];
		for (let i = 0; i < 31; i++)
		{ if (Math.pow(2, i) & mask)
		{ res.push(i); } }
		return res;
	},

	// e.g. util.fromMask(67,6) returns 1 because the 6th bit of 67 in 1
	isBitSetInMask: function(mask, bit) {
		return Math.pow(2, bit) & mask ? 1 : 0;
	},

	/* Mobile toggle */
	flipMobile: function() {
		const url = location.href.replace("m.okcupid", "okcupid").replace(/[&?](en|dis)able_mobile=1/g, "").split("#");
		url[0] += `${url[0].indexOf("?") != -1 ? "&" : "?"}enable_mobile=1`;
		location.href = url.join("#");
	},

	// places an element above the grazecovermanager
	placeOnTop: function(el) {
		jQuery(`#${el}`).css({ zIndex: "99999" });
	},

	/* Reload ads --------------------------------------------------------------------------- */
	reloadAds: function() {
		if (typeof DisplayAds === "undefined" || DisplayAds === null) {
			return;
		}
		window.DisplayAds.refreshAll();
	},

	// Gets that particular browser's scrollbar width.
	getScrollBarWidth: function() {
	  const inner = document.createElement("p");
	  inner.style.width = "100%";
	  inner.style.height = "200px";

	  const outer = document.createElement("div");
	  outer.style.position = "absolute";
	  outer.style.top = "0px";
	  outer.style.left = "0px";
	  outer.style.visibility = "hidden";
	  outer.style.width = "200px";
	  outer.style.height = "150px";
	  outer.style.overflow = "hidden";
	  outer.appendChild(inner);

	  document.body.appendChild(outer);
	  const w1 = inner.offsetWidth;
	  outer.style.overflow = "scroll";
	  let w2 = inner.offsetWidth;
	  if (w1 == w2) w2 = outer.clientWidth;

	  document.body.removeChild(outer);

	  return (w1 - w2);
	},

	// Allows swapping of content while retaining a height transition.
	// element - A jQuery element object.
	// content - arbitrary markup to place into the element.
	transitionContent: function(element, content) {
		let oldHeight,
			newHeight;

		// Swap in the new content
		if (content != "undefined" && content != null) {
			element.html(content);
		}

		// Grab the old height for future animation, disable animation
		element.addClass("noanimation");
		oldHeight = element.outerHeight();

		// Set to height auto, grab new height
		element.css("height", "auto");
		newHeight = element.outerHeight();

		// Assign old height, read it to force browser re-render
		element.css("height", oldHeight);
		oldHeight = element.outerHeight();

		// Re-allow animation, set to the new height to transition from old height
		element.removeClass("noanimation");
		element.css("height", newHeight);
	},
};



// WEBPACK FOOTER //
// ./src/legacy/Utilities.js